import { enumParser } from '#validation/common/parsers';
import { SsoEnforcementType } from '../constants';
export const ssoEnforcementTypeParser = enumParser(SsoEnforcementType);
